<template>
    <div class="container">
        <div class="backBox">
            <div class="back pointer" @click="back">
                <i class="el-icon-arrow-left"></i> 竞价申请
            </div>
            <div class="right">
                <div class="des text_ellipsis">
                    依据
                    <span class="color_primary pointer" @click="preview">《平台竞价规则》</span>
                    竞价成功后正式生成待支付订单，并且通知您及时支付...
                    <!-- <span class="count color_red">
                        当前竞价职位数：
                        <span>{{ 20 }} 个</span>
                    </span> -->
                </div>
                <!-- <div class="count color_red">
                   
                
                </div> -->
            </div>
        </div>
        <div class="content">
            <div class="queryBox">
                <el-form ref="ruleForm" style="display: flex;flex-wrap: wrap;">
                    <el-row type="flex">
                        <el-form-item label="职位类型：">
                            <el-cascader ref="positionTypeRef" v-model="formatObj.position_type_id" :options="options1"
                            clearable
                                :props="{
                                    checkStrictly: true,
                                    value: 'dict_id',
                                    label: 'dict_name',
                                }" filterable></el-cascader>

                        </el-form-item>
                        <el-form-item label="企业名称：" prop="">
                            <el-input v-model="postForm.enterprise_name" placeholder="请输入企业名称"></el-input>
                        </el-form-item>
                        <el-form-item label="职位名称：">
                            <el-input v-model="postForm.position_name" placeholder="请输入职位名称"></el-input>
                        </el-form-item>
<!--                        <el-form-item label="当前状态：">-->
<!--                            <el-select v-model="postForm.position_bidding_state" placeholder="请选择当前状态">-->
<!--                                <el-option v-for="item in options2" :key="item.dictionary_key"-->
<!--                                    :label="item.dictionary_value" :value="item.dictionary_key">-->
<!--                                </el-option>-->

<!--                            </el-select>-->
<!--                        </el-form-item>-->

                    </el-row>
                    <el-row type="flex" class="row2">
                        <el-form-item label="竞价时间：" prop="date">
                            <el-date-picker unlink-panels v-model="formatObj.date1" type="datetimerange" range-separator="-"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="企业标签：">
                            <el-checkbox-group v-model="postForm.tags_keys">
                                <el-checkbox v-for="item in options3" :key="item.dictionary_key"
                                    :label="item.dictionary_key">
                                    {{ item.dictionary_value }}
                                </el-checkbox>

                            </el-checkbox-group>
                            <el-button type="primary" size="mini" icon="el-icon-search" @click="search" class="margin_left_20">查询</el-button>
                            <el-button type="primary" size="mini" icon="el-icon-refresh-left" @click="reset">重置</el-button>

                        </el-form-item>
                       
                        <div class="form-btn">
                            <div>

                            </div>

                            <el-button type="primary" size="mini" icon="el-icon-search" class="bgc_orange"
                                @click="oper('1')">批量竞价</el-button>

                        </div>
                    </el-row>
                </el-form>
            </div>
            <div class="data_list">

                <el-table :data="tableData" row-key="code" border lazy :stripe="true" :highlight-current-row="true"
                    :header-cell-style="{ background: '#eee', color: '#606266' }" v-loading="loading"
                    element-loading-background="#fff" element-loading-text="数据正在加载中"
                    element-loading-spinner="el-icon-loading" ref="refTable" :height="'100%'"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="40"> </el-table-column>
                    <!-- <el-table-column prop="enterprise_name" label="图片编号" min-width="155"
        :show-overflow-tooltip="true"></el-table-column> -->
                    <el-table-column prop="name" label="职位情况" :show-overflow-tooltip="true" min-width="380">
                        <template v-slot="{ row }">
                            <div class="info">
                                <div class="img">
                                    <img :src="row.recruitment_enterprise_logo ? $imgUrl(row.recruitment_enterprise_logo) : require('@/assets/images/cr_default_logo.png')"
                                        alt="">
                                </div>
                                <div class="des">
                                    <div class="title">
                                        <span class="size16">
                                            {{ row.position_name }}
                                        </span>
                                        <span class="color_gray margin_left_10">
                                            <span class="padding_2">{{ row.position_type?row.position_type.join(' . '):'' }}</span>
                                        </span>
                                    </div>
                                    <div class="color_gray">
                                        {{ row.position_effective_start }}
                                        -
                                        {{ row.position_effective_end }}
                                    </div>
                                    <div class="color_gray">
                                        {{ row.recruitment_enterprise_name }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="intro" label="企业标签" min-width="200" :show-overflow-tooltip="true">
                        <template v-slot="{ row }">
                            <template v-if="row.enterprise_tags && row.enterprise_tags.length">
                                <el-tag v-for="(item, index) in row.enterprise_tags.map(item => item.tags_value)"
                                    :key="index">{{ item }}</el-tag>
                            </template>

                        </template>
                    </el-table-column>
                    <el-table-column prop="enterprise_name" label="竞价时间" min-width="160" :show-overflow-tooltip="true" sortable>
                        <template v-slot="{ row }">
                            <span>{{ row.position_bidding_start }}</span>
                            -
                            <span>{{ row.position_bidding_end }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="position_bidding_state" label="当前状态" min-width="70"
                        :show-overflow-tooltip="true">
                        <template v-slot="{ row }">
                            <div v-for="item in options2" :key="item.dictionary_key">
                                <span v-if="item.dictionary_key == row.position_bidding_state">
                                    {{ item.dictionary_value }}
                                </span>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="audit_state" label="当前价格" min-width="150" :show-overflow-tooltip="true">
                        <template #header>
                            当前价格￥
                        </template>
                        <template v-slot="{ row }">
                            <template v-if="!row.max_bidding_price">
                                <div class="color_red">未报价</div>
                            </template>
                            <template v-else>
                                <div class="color_red">{{ row.max_bidding_price }}</div>
                                <div class="color_gray text_ellipsis">{{ row.max_bidding_enterprise_name }}
                                </div>
                            </template>

                        </template>
                    </el-table-column>
                    <el-table-column prop="audit_state" label="我的报价" min-width="150" :show-overflow-tooltip="true">
                        <template #header>
                            我的报价￥
                        </template>
                        <template v-slot="{ row }">
                            <template v-if="!row.quoted_price">
                                <div class="color_red">未报价</div>
                            </template>
                            <template v-else>
                                <div class="color_red">{{ row.quoted_price }}</div>
                            <div class="color_gray text_ellipsis">{{ enterprise_name }}</div>
                            </template>
                           
                        </template>
                    </el-table-column>

                    <el-table-column width="80" fixed="right" label="操作">
                        <template slot-scope="{row}">
                            <div class="btn_column">
                                <el-button @click="oper('2', row)" type="text" size="small">竞价</el-button>
                                <span @click="oper('3', row)" type="text" size="small" class="pointer margin_left_10">
                                    详情</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>



            </div>
            <el-pagination class="pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30]"
                :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>

        </div>
        <dialogForm1 :id="1" ref="dialogForm1" @ok="ok('1')"></dialogForm1>
        <dialogForm2 :id="1" ref="dialogForm2" @ok="ok('2')"></dialogForm2>
        <dialogFormPreview :id="1" ref="dialogFormPreview" ></dialogFormPreview>
        <dialogFormPreview2 :id="1" ref="dialogFormPreview2" ></dialogFormPreview2>
    </div>
</template>

<script>
import dialogForm1 from './components/dialogForm1.vue'//课程
import dialogForm2 from './components/dialogForm2.vue'//大纲
import dialogFormPreview from './components/dialogFormPreview.vue'//预览
import dialogFormPreview2 from './components/dialogFormPreview2.vue'//预览
export default {
    components: {
        dialogForm1,
        dialogForm2,
        dialogFormPreview,
        dialogFormPreview2
    },
    data() {
        return {
            options1: [],
            options2: [],
            options3: [
                // {
                //     value: '0',
                //     label: '知名企业'
                // },
                // {
                //     value: '1',
                //     label: '上市企业'
                // },
                // {
                //     value: '2',
                //     label: '央企国企'
                // },
                // {
                //     value: '3',
                //     label: '中小民企'
                // },

            ],
            // 搜索区域
            formatObj: {
                date1: [],
                position_type_id: []
            },
            // 分页
            pagesize: 10,
            currentPage: 1,
            total: 0,
            loading: false,
            // 课程视频选择
            checkList: [],
            // 表格数据
            enterpriseOptions: JSON.parse(localStorage.getItem('entinfolist')),
            "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
            enterprise_name: '',
            tableData: [],
            postForm: {
                page: 1,
                limit: 10,
                enterprise_id: localStorage.getItem('enterprise_id'),//企业唯一标识
                "position_type_id": "",//类型
                "enterprise_name": "",//企业名称
                "position_name": "",//职位名称
                // "position_bidding_state": "",//竞价状态
                "position_bidding_start": "",//竞价开始时间
                "position_bidding_end": "",//竞价结束时间
                tags_keys: [],//标签
                // "contents_id": "",//课程大纲目录 ID

                // "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
            },
        }
    },
    created() {
        this.getPostionTypeOptions()
        this.getDictsData('HR-KJ-KC-JJSQ-JSZT', 'options2')
        this.getDictsData('CM-BQ', 'options3')
        this.getList()
        let obj = this.recursion(this.enterpriseOptions)
        this.enterprise_name = obj.enterprise_name
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        preview() {
            this.$refs.dialogFormPreview.dialogVisible = true
            this.$refs.dialogFormPreview.init()
        },
       
        // 递归
        recursion(arr) {
            let obj;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].options) {
                    obj = this.recursion(arr[i].options)
                    if (obj) {
                        return obj
                    }
                }
                if (arr[i].enterprise_id && arr[i].enterprise_id == this.enterprise_id) {
                    // obj = arr[i]

                    return arr[i];
                }
            }

        },
        // 获取数据字典值
        async getDictsData(dict, optionsNmae) {
            let options = [];
            await this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        dictionary_code: dict,
                    },
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        options = res.data.data.dictionary_detail;
                    } else {
                        // this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                });
            this[optionsNmae] = options;
        },
        // 获取职位类型级联下拉
        getPostionTypeOptions() {
            this.$tools
                .asyncPost(this, this.$baseUrl.hierdictlist, {})
                .then((res) => {
                    if (res.data.code == 0) {
                        this.options1 = res.data.data;
                    } else {
                        // this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                });
        },
        getList() {
            this.loading = true;
            this.postForm.page = this.currentPage
            this.postForm.limit = this.pagesize
            let formaterFileds = {
                position_bidding_start: this.formatObj.date1.length ? this.formatObj.date1[0] : "",
                position_bidding_end: this.formatObj.date1.length ? this.formatObj.date1[1] : "",
                position_type_id: this.formatObj.position_type_id.length ? this.formatObj.position_type_id[this.formatObj.position_type_id.length - 1] : "",
            }
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.biddingApplicationList, {
                    data: Object.assign(this.postForm, formaterFileds)
                }).then((res) => {
                    if (res.data.code == 0) {

                        this.tableData = res.data.data.data

                        console.log(this.tableData);
                        this.total = res.data.data.total
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.loading = false;
                }).catch((err) => { this.loading = false; });
        },
        oper(type, row) {
            switch (type) {
                case '1':
                    if (this.checkList.length == 0) {
                        return this.$message({ type: "error", message: "请选择数据" });
                    }
                    this.$refs.dialogForm1.dialogVisible = true
                    this.$refs.dialogForm1.init(this.checkList)
                    break;
                case '2':

                    this.$refs.dialogForm2.dialogVisible = true
                    this.$refs.dialogForm2.init(row)
                    break;
                case '3'://查看
                    this.$refs.dialogFormPreview2.dialogVisible = true
                    this.$refs.dialogFormPreview2.init(row)
                default:
                    break;
            }
        },
        ok(type) {
            switch (type) {
                case '1':
                    this.getList()
                    break;
                case '2':
                    this.getList()
                    break;
                default:
                    break;
            }
        },
        handleSelectionChange(val) {
            this.checkList = val
        },
        handleSizeChange: function (size) {
            this.pagesize = size; //每页下拉显示数据
            this.getList();
        },
        handleCurrentChange: function (currentPage) {
            this.currentPage = currentPage; //点击第几页
            this.getList();
        },
        search() {
            // console.log(value);
            // this.postForm1.enterprise_id = value
            this.currentPage = 1

            this.getList()

        },
        // 重置
        reset() {

            let obj = {
                "position_type_id": "",//类型
                "enterprise_name": "",//企业名称
                "position_name": "",//职位名称
                "position_bidding_state": "",//竞价状态
                "position_bidding_start": "",//竞价开始时间
                "position_bidding_end": "",//竞价结束时间
                tags_keys: [],//标签
            }
            Object.keys(obj).forEach((key) => {
                this.postForm[key] = obj[key];
            });
            this.formatObj.date1 = []
            this.formatObj.position_type_id = []

            this.currentPage = 1;
            // this.pagesize = 10;
            this.getList()
        },
    }
}
</script>

<style scoped lang="less" src="./index.less"></style>